// extracted by mini-css-extract-plugin
export var bellring = "V_c0";
export var boxErrorContainer = "V_cV";
export var boxErrorWrapper = "V_cZ";
export var boxErrordanger = "V_cY";
export var boxErrorinfo = "V_cW";
export var boxErrorwarning = "V_cX";